<template>
  <ModalFullScreen
    v-model="dialog"
    content-class="select-offers-for-copy-fullscreen rounded-0"
    fullscreen
    no-click-animation
    persistent>
    <template
      #activator="{ on }">
      <sButton
        data-qa="select-offers-for-copy"
        :disabled="disabled"
        :loading="loading"
        @click="open(on)">
        {{ $t('Tenders.Continue') }}
      </sButton>
    </template>
    <RefineComponent
      id="select-offers-for-copy"
      :element="tender"
      :title="$t('Tenders.SelectOffers')">
      <template #bread>
        <TenderBreadcrumbs
          :check-exit="checkChages"
          :dialog.sync="dialog"/>
      </template>
      <template #step>
        <div class="h9-label text-start mb-2">
          {{ $t('Catalog.Step') }} {{ $t('Tenders.SettingCopyOffers') }}
        </div>
      </template>
      <template #next_step>
        <NextStep
          :name="$t('Tenders.TenderInformation')"
          step="1"/>
      </template>
      <template #table>
        <sIcon
          v-if="load_info"
          color="var(--secondary__green_not_active)"
          size="22"
          spin
          type="loading"/>
        <OffersTab
          v-else
          ref="offers_tab"
          :critery-card="criteryCard"
          infinity_selector="#refine-table-container"
          :map-bids="mapBids"
          :map-groups="mapGroups"
          only_active
          only_review
          :select="select"
          :tender="item"/>
      </template>
      <template #footer>
        <ComponentFooter
          key="footer"
          ref="footer"
          :back="backStep"
          back_btn
          :loading="loading_coping"
          :next="submit">
          <template #next>
            <sBadge
              color="var(--v-secondary__green_chosen-base)"
              :content="selected_bids.length"
              data-qa="select-offers-for-copy-badge"
              offset-x="15"
              offset-y="10"
              overlap
              text-color="var(--black-color)"
              :value="selected_bids.length">
              <sButton
                :disabled="loading_coping"
                :loading="loading_coping"
                @click="submit">
                {{ $t('Common.Next') }}
              </sButton>
            </sBadge>
          </template>
        </ComponentFooter>
      </template>
    </RefineComponent>
  </ModalFullScreen>
</template>
<script>
import NextStep from 'components/tenders/NextStep.vue'
import RefineComponent from 'pages/templates/RefineComponent.vue'
import TenderBreadcrumbs from 'components/tenders/TenderBreadcrumbs.vue'
import ComponentFooter from 'components/common/blocks/ComponentFooter.vue'
import OffersTab from 'components/tenders/tender page/tender tabs/OffersTab.vue'

import ModalFullScreen from 'components/common/elements/ModalFullScreen.vue'

export default {
  name: 'selectOffersForCopy',
  data() {
    return {
      dialog: false,
      loading_coping: false,
      load_info: false,
      possible_bids: [],
      selected_bids: [],
      criteryCard: {},
      item: {}
    }
  },
  props: {
    copy_offers_files: {
      type: Boolean,
      required: true
    },
    tender: {
      type: Object,
      required: true
    },
    validate: {
      type: Function
    },
    copyTender: {
      type: Function
    },
    loading: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  methods: {
    async open() {
      await this.validate().then(async () => {
        this.dialog = true

        this.load_info = true
        if ( !this.tender.bids ) {
          await this.$store.dispatch('getTenderItem', {id: this.tender.tenderId })
            .then(res => {
              this.item = this.$_.cloneDeep(res)
            })
        } else  {
          this.item = this.$_.cloneDeep(this.tender)
        }
        this.criteryCard = await this.$store.dispatch('infoAboutCriterionCard', {save: true, id: this.item.criteriaCard})
        this.load_info = false
        setTimeout(() => {
          this.$refs.offers_tab?.applyOfferSearch()
        }, 100)
        // Помилки валідації (напр. незаповнена причина) вже показані інлайн у формі — тут лише глушимо reject
      }).catch(() => {})
    },
    checkChages() {
      return this.selected_bids?.length
    },
    backStep() {
      if (this.checkChages()) {
        this.$root.$emit('showExitConfirmation', { submitExit: this.close })
      } else {
        this.close()
      }
    },
    async submit() {
      this.loading_coping = true
      await this.copyTender(this.selected_bids)
      this.loading_coping = false
      this.dialog = false
    },
    close() {
      this.dialog = false
    },
    select(selected, group, selected_items) {
      this.selected_bids = selected_items
    },
    mapBids(bid) {
      bid.copy_attachments = !!bid.attachments?.length && this.copy_offers_files
      return bid
    },
    mapGroups(groups) {
      groups.forEach(gr => {
        let formatHeaders = gr.formatHeaders
        gr.formatHeaders = (headers) => {
          headers = formatHeaders ? formatHeaders(headers) : headers
          headers.splice(-1, 0,
            { text: this.$t('Tenders.CopyAttachments'), value: 'copy_attachments', coef_width: '1', class: 'header_break-spaces' },)
          return headers
        }
      })
      return groups
    }
  },
  components: {
    NextStep,
    OffersTab,
    RefineComponent,
    ComponentFooter,
    ModalFullScreen,
    TenderBreadcrumbs,
  }
}
</script>
